import React from 'react';
import styled from 'styled-components';
import { bool, node, oneOf } from 'prop-types';
import Checkmark from '../../Icons/Checkmark';

const ListItemStyled = styled.li`
    ${({ listCheckMarks }) =>
        listCheckMarks &&
        `
        display:flex;
        gap:8px;
        `}
    &::marker {
        ${({ theme }) => `color: ${theme.colorSystem.secondary[3]};`}
    }
    ol > &::marker {
        ${({ theme }) => `color: ${theme.colorSystem.primary[1]};`}
    }
`;
const ListItem = ({
    listCheckMarks,
    listTickVariant = 'green',
    children
}) => {
    return (
        <ListItemStyled listCheckMarks={listCheckMarks}>
            {listCheckMarks && (
                // prevents svg shrinking when line content is long
                <div>
                    <Checkmark variant={listTickVariant} />
                </div>
            )}
            {children}
        </ListItemStyled>
    );
};

ListItem.propTypes = {
    children: node.isRequired,
    listCheckMarks: bool,
    listTickVariant: oneOf(['blue', 'green'])
};
ListItem.defaultProps = {
    listCheckMarks: false,
    listTickVariant: 'green'
};

export default ListItem;
